export default {
    'diagram3b1-2': {
        'checkboxes': {
            'title': 'Question:	',
            'checkbox-1': 'Why do they?',
            'checkbox-2': 'How do they?',
            'checkbox-3': 'How do you know they do?',
        },
        'elements': {
            'one': 'Companies often use their information systems to satisfy accounting rather than operating needs',
            'two': 'They utilize comparisons irrelevant to operating decisions',
            'three': 'They force fixed standards on variable operating activity',
            'four': 'They ignore organizational realities in grouping data'
        },
        'checkboxes-bottom': {
            'title': 'General Plural Noun',
            'checkbox-1': 'Reasons',
            'checkbox-2': 'Steps',
            'checkbox-3': 'Proofs',
        },
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b1/diagram2/i18n/en.js